import { Link } from 'gatsby';
import React from 'react';

const Breadcrumb = ({ previous, current }) => {
  const linkText = previous === 'about' ? 'About Us' : previous === 'projects' ? 'Projects' : 'Solutions';

  return (
    <div>
      <nav aria-label='breadcrumb'>
        <ol className='breadcrumb' style={{ justifyContent: 'center' }}>
          <li className='breadcrumb-item'>
            <Link to='/'>Home</Link>
          </li>
          <li className='breadcrumb-item'>
            <Link to={`/${previous}`}>{linkText}</Link>
          </li>
          <li className='breadcrumb-item active' aria-current='page'>
            {current}
          </li>
        </ol>
      </nav>
    </div>
  );
};

export default Breadcrumb;
